import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import { UiKitInputBase } from '@/fo/ui/kit/input/base';
import { UiKitTextareaBase } from '@/fo/ui/kit/textarea/base';
import { useForm } from '@/fo/ui/mod/form/base';

import { FormFooter } from '../FormFooter/FormFooter';
import { RatingField } from '../RatingField/RatingField';

import { styles } from './CommentForm.styles';
import { formAction } from './formAction';

export interface CommentFormProps {
  onSuccess?: () => void;
  postId: number;
  onClose?: () => void;
}

export function CommentForm({ onSuccess, postId, onClose }: CommentFormProps) {
  const slots = styles();
  const t = useTranslations();

  const { getFieldProps, pending, isDirty, state, action } =
    useForm(formAction);

  const isSuccess = state.status === 'success';

  useEffect(() => {
    if (isSuccess) {
      onSuccess?.();
    }
  }, [isSuccess, onSuccess, onClose]);

  return (
    <div className={slots.base()}>
      <form
        className={slots.base()}
        noValidate
        action={action}
      >
        <input
          type="hidden"
          name="post_id"
          value={postId}
        />
        <RatingField {...getFieldProps('rating')} />
        <div className={slots.form()}>
          <UiKitInputBase
            required
            {...getFieldProps('user_name')}
            label={t('form.label.name')}
          />
          <UiKitTextareaBase
            required
            label={t('comment.form.comment.label')}
            {...getFieldProps('content')}
          />
        </div>
        <FormFooter
          pending={pending}
          isDirty={isDirty}
        />
      </form>
    </div>
  );
}
